module.exports = __webpack_public_path__ + "static/img/logo.1769678785359.png";